import {
  Alert,
  AlertIcon,
  Heading,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { useFormState } from 'web-react-ui/src/reactFinalForm';
import DateTimeField from 'web-react-ui/src/reactFinalForm/fields/dateTimeField/DateTimeField';
import Post from '../../interfaces/Post.interface';

const ScheduledDateSection = ({ post }: { post: Post }) => {
  const formState = useFormState();
  const willGoLive = post.state !== 'draft' && new Date(formState.values.scheduledDate) <= Date.now();
  return (
    (
      <>
        <Heading fontSize="1.5em" pb="1em">Scheduled Date</Heading>
        <DateTimeField
          name="scheduledDate"
          minDate={new Date()}
        />
        {
          willGoLive && (
            <Alert status="info">
              <AlertIcon />
              This will be posted immediately on Save
            </Alert>
          )
        }
      </>
    )
  );
};

export default ScheduledDateSection;;
